<!--
 * @Author: wangwang 2723008256@qq.com
 * @Date: 2023-08-11 09:06:57
 * @LastEditors: 番茄炒蛋蛋 wzh15802755802@163.com
 * @LastEditTime: 2025-02-28 13:27:25
 * @FilePath: \jzjypc4.2\src\components\yuyueBox\yuyuebox.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="yuyueevm">
    <el-dialog
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      width="800px"
      top="30vh"
    >
      <div class="yyevmContent">
        <div class="contentgq">
          <div class="top">
            <h2><span>免费试用</span>体验已结束！</h2>
            <div class="bao">
              <p>一键升级</p>
              <h2>平台正式账号+高中全学年教学包</h2>
              <img
                src="../../assets/img/lijichakan.gif"
                @click="yijian"
                alt=""
              />
            </div>
          </div>
          <div class="neirong">
            <div class="evm">
              <div class="pic">
                <img :src="zykf_file_url" alt="" />
              </div>
              <p>若继续体验，请扫一扫添加客服咨询</p>
            </div>
            <div class="right">
              <div class="bao">
                <div class="msg wenzi" @click="yijian">
                  <div class="list" style="margin-top: 14px">
                    <span>全面解锁</span>
                    <p>
                       享受平台免费及VIP所有资源下载及使用权限
                    </p>
                  </div>
                  <div class="list">
                    <span>无限观看</span>
                    <p>
                       知名专家教研课、教学课、重点主题教研活动随 时观看，反复回放
                    </p>
                  </div>
                  <div class="list">
                    <span>精编精校</span>
                    <p >
                       每个资源和课程都经过瑞鑫教研团队及一线专家 潜心打磨，层层审校
                    </p>
                  </div>
                  <div class="list">
                    <span>专属客服</span>
                    <p >
                       教学包内容自动打包、定期推送，省时省心
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ["zykf_file_url", ],
  inject: ["reload"],
  data() {
    return {
      dialogVisible: true,
      dqkfevm: "", //公众号二维码
      width: "560px",
      right_left: "60px",
    };
  },
  created() {
    console.log()
  },
  methods: {
    handleClose() {
      this.$emit("guoqiClose");
    },
    yijian() {
      this.$router.push({
            name: "Dingzhi",
            query: {
            kemu_id:1,
            type:'dy',
            gopay:1,
            leixing:0
            },
        });
    },
  },
};
</script>

<style lang="less" scoped>
.yuyueevm {
  /deep/.el-dialog__header {
    padding: 0;
  }
  /deep/.el-dialog {
    margin-top: 13vh !important;
    border-radius: 20px;
    border-radius: 20px;
    background: #7a787800 !important;
    box-shadow: none;
  }
  /deep/.el-dialog__body {
    padding: 0;
    height: 450px;
    height: 100% !important;
  }
  /deep/.el-dialog__headerbtn .el-dialog__close {
    color: #fff !important;
  }
  .yyevmContent {
    width: 800px;
    height: 470px;
    border-radius: 20px;
    background-image: url("../../assets/img/guoqibg.png");
    background-size: 100%;
    background-repeat: no-repeat;
    overflow: hidden;
    .contentgq {
      .top {
        margin-top: 80px;
        h2 {
          margin-left: 40px;
          font-size: 24px;
          color: #333;
          span {
            color: #1E60EB;
          }
        }
        .bao {
          display: flex;
          align-items: center;
          margin-top: 18px;
          margin-left: 40px;
          p {
            // margin-left: 60px;
            font-size: 16px;
            color: #333;
          }
          h2 {
            font-size: 24px;
            margin-left: 18px;
            margin-right: 20px;
            color: #1E60EB;
          }
          h4 {
            font-size: 20px;
            color: #333;
            margin-right: 15px;
          }
          img {
            position: relative;
            top: 4px;
            width: 120px;
            cursor: pointer;
            user-select: none;
          }
          img:active {
            opacity: 0.8;
          }
        }
      }
    }
    .neirong {
        display: flex;
      .evm {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 20px;
        margin-left: 40px;
        padding-right: 40px;
        .pic {
        margin-bottom: 16px;
          width: 200px;
          height: 200px;
          // border: 1px solid #ccc;
          img{
            width: 100%;
          }
        }
        p{
            font-size: 12px;
            color: #999;
        }
      }

      .msg {
        margin-top: 20px;
        // margin-left: 60px;
        width: 472px;
        height: 224px;
        border: 4px solid #1E60EB;
        border-radius: 12px;
        background: #f5faf8;
        margin-bottom: 30px;
        cursor: pointer;
        .list {
          display: flex;
          margin-bottom: 14px;
          margin-left: 20px;
          span {
            display: inline-block;
            text-align: center;
            margin-right: 10px;
            line-height: 24px;
            width: 24px;
            height: 24px;
            background: linear-gradient(150deg, #1E60EB, #457aec);
            border-radius: 4px;
            color: #fff;
            font-size: 20px;
            font-weight: 600;
            font-family: fangsong;
          }
          p {
            width: 320px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            color: #333333;
            line-height: 24px;
          }
        }
      }
      .wenzi {
        .list {
          span {
            width: auto;
            padding: 2px 6px;
            font-size: 17px;
          }
        }
      }
    }
  }
}
</style>